import {
  Currency,
  SupportedCurrency,
} from '@sorare/core/src/__generated__/globalTypes';

import { UserAccountEntries } from '@sorare/marketplace/src/components/mySorare/TransactionsHistory/UserAccountEntries';

const Page = () => {
  return (
    <UserAccountEntries
      currency={Currency.ETH}
      cryptocurrency={SupportedCurrency.WEI}
    />
  );
};

export default Page;
